import { useTheme } from "./theme"
import { getBadgeColors, getDefaultColor } from "../lib/colors"

export function LabelBadge({
  label,
  color,
  index,
  onClick,
  className = "",
}: {
  label: string
  color?: string | null
  index?: number
  onClick?: () => void
  className?: string
}) {
  const { theme } = useTheme()
  const c = color || getDefaultColor(index ?? 0)
  const { bg, text } = getBadgeColors(c, theme)
  return (
    <span
      className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${className}`}
      style={{ backgroundColor: bg, color: text }}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      {label}
    </span>
  )
}
